import React from "react";

const LanguageLandingHero = ({ onBookDemo, onExploreCourses }) => {
  return (
    <section id="ll-hero" className="ll-hero">
      <div className="container">
        <div className="ll-hero__grid">
          <div className="ll-hero__content wow fadeInUp">
            <span className="ll-hero__badge">
              Learn Languages. Unlock Opportunities.
            </span>
            <h1 className="ll-hero__title">
              Speak the World&apos;s Languages —{" "}
              <span>Live, Online &amp; Affordable</span>
            </h1>
            <p className="ll-hero__subtitle">
              Join Koderbox for live Japanese, German, French, Spanish, Korean
              &amp; Chinese classes with expert trainers. Flexible timings.
              Proven results.
            </p>
            <div className="ll-hero__ctas">
              <button type="button" className="ll-btn ll-btn--primary" onClick={onBookDemo}>
                Book Free Demo Class
              </button>
              <button type="button" className="ll-btn ll-btn--secondary" onClick={onExploreCourses}>
                Explore Courses
              </button>
            </div>
            <div className="ll-hero__trust">
              <div className="ll-hero__trust-item">
                <strong>500+</strong>
                <span>Students</span>
              </div>
              <div className="ll-hero__trust-item">
                <strong>Expert</strong>
                <span>Trainers</span>
              </div>
              <div className="ll-hero__trust-item">
                <strong>Live</strong>
                <span>Classes</span>
              </div>
              <div className="ll-hero__trust-item">
                <strong>Certified</strong>
                <span>Courses</span>
              </div>
            </div>
          </div>

          <div className="ll-hero__visual wow fadeInUp" data-wow-delay="0.2s">
            <div className="ll-hero__card">
              <span className="ll-hero__live">Live Class in Progress</span>
              <strong>Choose Your Language</strong>
              <div className="ll-hero__langs">
                <div>🇯🇵 Japanese</div>
                <div>🇩🇪 German</div>
                <div>🇫🇷 French</div>
                <div>🇪🇸 Spanish</div>
                <div>🇰🇷 Korean</div>
                <div>🇨🇳 Chinese</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LanguageLandingHero;
